import BaseListPresenter from "../../../../base/BaseListPresenter";
import ExportCSVFunction from "../../../../components/ExportCSVFunction";

class AssignedUserPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase,
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
    this.view = view;
  }

  init() {
    const object = this.view.props.object;
    this.limit = 2000;
    this.where = {
      serialNum: { $in: [object.id] },
    };
    this.search = {};
    this.filter = {};
    this.include = ["employee"];
    this.keys = [
      "username",
      "employeeAgencyNum",
      "employee.Firstname",
      // "employee.Middlename",
      "employee.surname",
      "employee.agency",
    ]; // if keys are specified, only those keys will be returned
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }

  createQuery() {
    const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      skip: skip,
      where: { ...this.where, ...this.search, ...this.filter },
      include: this.include,
    };
    if (this.sort) {
      query.sort = this.sort;
    }
    const keys = this.keys || this.view.getKeys() || [];
    if (keys.length > 0) {
      query.keys = keys;
    }
    return query;
  }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const query = this.createQuery();
    try {
      this.showProgress();
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);
      objects.forEach((object) => {
        object.employeeAgencyNum = object?.employee?.agency || "";
      });
      objects.sort((a, b) => {
        const surnameA = a.employee?.surname?.toLowerCase() || "";
        const surnameB = b.employee?.surname?.toLowerCase() || "";

        // Compare surnames
        if (surnameA < surnameB) {
          return -1; // a comes before b
        }
        if (surnameA > surnameB) {
          return 1; // b comes before a
        }
        return 0; // a and b are equal
      });

      this.objects = this.objects.concat(objects);
      this.view.setObjects(objects);
      this.view.setCurrent(this.current);
      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  setCurrentPage(page) {
    this.current = page;
    this.documents = [];
    this.view.setCurrent(page);
    this.view.setObjects([]);
    this.findObjects();
  }

  async handleExportToCSV(objects, exportName, schema) {
    const newSchema = { ...schema };
    const newObject = [...objects];
    newSchema.fields = {
      employeeName: { type: "String" },
      ...newSchema.fields,
    };
    newObject.forEach((object) => {
      object.employeeName = `${object?.employee?.surname || ""}, ${
        object?.employee?.Firstname || ""
      } ${object?.employee?.Middlename || ""}`;
    });
    const exportField = ["employeeName", ...this.keys];
    // console.log("OBJECTS: ", newObject);
    // return;
    ExportCSVFunction(newObject, exportName, newSchema, exportField);
  }
}

export default AssignedUserPresenter;
